import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoahmedabadcab() {



  const cardData = {
    keyword: " Mumbai to Ahmedabad Cab",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Ahmedabad cab services, ensuring a safe, smooth, and hassle-free long-distance journey for families, business travelers, and group passengers. Ahmedabad is a major commercial and cultural hub of Gujarat, known for its heritage architecture, textile markets, modern infrastructure, and vibrant food culture, making it one of the most important intercity travel routes from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Ahmedabad route covers approximately 525 to 540 km via NH48 and takes around 8 to 10 hours depending on traffic, road conditions, and stoppages. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Ahmedabad travel.",

"topPlaces": [
  {
    "title": "Sabarmati Riverfront",
    "description": "Sabarmati Riverfront is one of Ahmedabad’s most iconic modern attractions, developed along the banks of the Sabarmati River. It features beautifully designed promenades, gardens, cycling tracks, boating areas, and open spaces for relaxation. Visitors can enjoy peaceful morning walks, evening sunsets, cultural events, and street food experiences along the vibrant waterfront that has become a symbol of the city’s urban transformation."
  },
  {
    "title": "Sabarmati Ashram",
    "description": "Sabarmati Ashram, also known as Gandhi Ashram, is one of the most important historical sites in India associated with Mahatma Gandhi. It served as his residence during the freedom struggle and is now a museum preserving his life, principles, and belongings. Visitors experience a deep sense of history, simplicity, and non-violence philosophy while exploring the ashram’s peaceful environment on the banks of the Sabarmati River."
  },
  {
    "title": "Adalaj Stepwell",
    "description": "Adalaj Stepwell is a stunning example of Indo-Islamic architecture located near Ahmedabad, built in the 15th century. It features intricate carvings, multi-level platforms, and a unique cooling structure designed to provide water access and shelter. The stepwell showcases exceptional craftsmanship and remains a major attraction for history lovers, photographers, and architecture enthusiasts."
  },
  {
    "title": "Kankaria Lake",
    "description": "Kankaria Lake is one of the largest lakes in Ahmedabad and a popular recreational hub for families and tourists. It offers boating, toy train rides, balloon rides, zoo visits, and amusement activities around its circular promenade. The lakefront becomes especially lively in the evenings with lights, food stalls, and entertainment zones creating a festive atmosphere."
  },
  {
    "title": "Akshardham Temple (Gandhinagar)",
    "description": "Akshardham Temple near Ahmedabad is a magnificent spiritual complex dedicated to Lord Swaminarayan. Known for its grand architecture, detailed carvings, exhibitions, and musical fountain shows, it attracts devotees and tourists from across India. The temple offers a peaceful spiritual experience combined with cultural learning and visual storytelling."
  },
  {
    "title": "Calico Museum of Textiles",
    "description": "The Calico Museum of Textiles is one of the finest textile museums in India, showcasing ancient fabrics, traditional weaving techniques, royal garments, and historical textile art. It reflects Ahmedabad’s deep-rooted connection with the textile industry and offers guided tours that highlight centuries of craftsmanship and heritage."
  },
  {
    "title": "Manek Chowk",
    "description": "Manek Chowk is a bustling marketplace in Old Ahmedabad that transforms from a jewelry market in the day to a famous street food hub at night. Visitors can explore local Gujarati cuisine, vibrant stalls, and historic surroundings, making it one of the most lively and authentic cultural experiences in the city."
  },
  {
    "title": "Jama Masjid Ahmedabad",
    "description": "Jama Masjid is a historic mosque built in the 15th century showcasing stunning Indo-Islamic architecture with yellow sandstone pillars and carved domes. It stands as a symbol of Ahmedabad’s rich architectural heritage and offers a peaceful atmosphere for visitors interested in history and culture."
  },
  {
    "title": "Auto World Vintage Car Museum",
    "description": "The Auto World Vintage Car Museum features a unique collection of classic and luxury vintage cars, including Rolls Royce, Bentley, and other rare automobiles. It is a must-visit attraction for automobile enthusiasts and families interested in automotive history and royal transport collections."
  },
  {
    "title": "Science City Ahmedabad",
    "description": "Science City is a modern educational and entertainment complex featuring interactive science exhibits, an IMAX theatre, robotics displays, and aquatic galleries. It is designed to promote learning through fun experiences and is especially popular among students, families, and science enthusiasts."
  }
],







services: [
  {
    name: "Mumbai to Ahmedabad Cab",
    description: "Mumbai to Ahmedabad cab service offers a smooth and comfortable long-distance journey connecting Maharashtra with Gujarat’s major commercial hub. The route via NH48 ensures fast and scenic highway travel. Ideal for business travelers, families, and tourists, this service provides safe and timely transportation. Professional drivers and well-maintained vehicles enhance comfort. Multiple vehicle options are available. It guarantees a reliable and hassle-free journey."
  },
  {
    name: "Mumbai to Ahmedabad Taxi",
    description: "Mumbai to Ahmedabad taxi provides convenient and private travel with door-to-door pickup and drop. This service is ideal for travelers looking for a comfortable and flexible ride. Vehicles are clean and driven by experienced chauffeurs. Suitable for both business and personal trips. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Ahmedabad Cab Service",
    description: "Mumbai to Ahmedabad cab service is designed for efficient intercity travel with a focus on comfort and safety. The highway route ensures a smooth and quick journey. This service is perfect for corporate travel, family trips, and long-distance travel needs. Vehicles are maintained for performance. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Ahmedabad Taxi Service",
    description: "Mumbai to Ahmedabad taxi service offers reliable long-distance travel with professional drivers and clean vehicles. This service is suitable for families, business travelers, and tourists. Flexible scheduling allows easy trip planning. Door-to-door service enhances convenience. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Ahmedabad",
    description: "Cab from Mumbai to Ahmedabad provides a personalized travel experience with flexible stops along the route. Travelers can enjoy a comfortable and private journey. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a relaxed road trip experience."
  },
  {
    name: "Taxi from Mumbai to Ahmedabad",
    description: "Taxi from Mumbai to Ahmedabad offers a convenient and efficient way to travel between the two cities. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for business and leisure travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Ahmedabad Cab Booking",
    description: "Mumbai to Ahmedabad cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Ahmedabad Taxi Booking Online",
    description: "Mumbai to Ahmedabad taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Ahmedabad Cab Price",
    description: "Mumbai to Ahmedabad cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Ahmedabad Taxi Fare",
    description: "Mumbai to Ahmedabad taxi fare is designed to be affordable and competitive for long-distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Ahmedabad One Way Cab",
    description: "Mumbai to Ahmedabad one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for business trips and relocations. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Ahmedabad Round Trip Taxi",
    description: "Mumbai to Ahmedabad round trip taxi is ideal for travelers planning a return journey. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for business and family travel. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Ahmedabad Innova Cab",
    description: "Mumbai to Ahmedabad Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for long-distance journeys. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Ahmedabad Ertiga Cab",
    description: "Mumbai to Ahmedabad Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Ahmedabad Sedan Cab",
    description: "Mumbai to Ahmedabad sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Ahmedabad SUV Taxi",
    description: "Mumbai to Ahmedabad SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Ahmedabad Cab",
    description: "Cheap Mumbai to Ahmedabad cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Ahmedabad Taxi Service",
    description: "Best Mumbai to Ahmedabad taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Ahmedabad Cab", "Mumbai to Ahmedabad Taxi"],
  ["Mumbai to Ahmedabad Cab Service", "Mumbai to Ahmedabad Taxi Service"],
  ["Cab from Mumbai to Ahmedabad", "Taxi from Mumbai to Ahmedabad"],
  ["Mumbai to Ahmedabad Cab Booking", "Mumbai to Ahmedabad Taxi Booking Online"],
  ["Mumbai to Ahmedabad Cab Price", "Mumbai to Ahmedabad Taxi Fare"],
  ["Mumbai to Ahmedabad One Way Cab", "Mumbai to Ahmedabad Round Trip Taxi"],
  ["Mumbai to Ahmedabad Innova Cab", "Mumbai to Ahmedabad Ertiga Cab"],
  ["Mumbai to Ahmedabad Sedan Cab", "Mumbai to Ahmedabad SUV Taxi"],
  ["Cheap Mumbai to Ahmedabad Cab", "Best Mumbai to Ahmedabad Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ahmedabad Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Ahmedabad cab service, ideal for business trips, family travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Ahmedabad highway routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Ahmedabad cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel options for Ahmedabad trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Ahmedabad cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Ahmedabad cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Ahmedabad for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Ahmedabad?", answer: "The distance is approximately 520 to 540 km and takes around 9 to 11 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Ahmedabad cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during peak travel seasons and long-distance trips." },
  { question: "Do you provide night travel service?", answer: "Yes, we provide safe night travel with experienced drivers." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pratik Shah",
    feedback: "The Mumbai to Ahmedabad journey with Royal Route Cabs was extremely comfortable and well-managed. The driver was experienced and ensured a safe long-distance travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Komal Mehta",
    feedback: "Smooth and stress-free travel from Mumbai to Ahmedabad. Royal Route Cabs provided a clean cab and professional service throughout the entire trip.",
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ahmedabad Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-ahmedabad-cab.jpg", // replace if needed
  "description": "Book Mumbai to Ahmedabad cab with Royal Route Cabs for a safe, comfortable, and affordable long-distance journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-ahmedabad-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Ahmedabad Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Ahmedabad cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to ahmedabad cab, mumbai to ahmedabad taxi, mumbai to ahmedabad cab service, mumbai to ahmedabad taxi service, cab from mumbai to ahmedabad, taxi from mumbai to ahmedabad, mumbai to ahmedabad cab booking, mumbai to ahmedabad taxi booking online, mumbai to ahmedabad cab price, mumbai to ahmedabad taxi fare, mumbai to ahmedabad one way cab, mumbai to ahmedabad round trip taxi, mumbai to ahmedabad innova cab, mumbai to ahmedabad ertiga cab, mumbai to ahmedabad sedan cab, mumbai to ahmedabad suv taxi, cheap mumbai to ahmedabad cab, best mumbai to ahmedabad taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoahmedabadcab;